import React from 'react';
import { INITIAL_SLIDE, NEXT, PREV } from '../../SlickSlider/constants';
import CustomArrow from '../../SlickSlider/CustomArrow';

export const createSliderSettings = ({
    breakpoints = [],
    isInfinite = true,
    useDots = false,
    useArrows = true,
    slidesToShow,
    autoplay = false,
    smallArrows = false,
    onArrowClick = Function.prototype,
    autoplaySpeed,
    initialSlide = INITIAL_SLIDE,
    slidesToScroll,
    speed,
    easing,
    useTransform
}) => {
    const sliderSettings = {
        dots: useDots,
        infinite: isInfinite,
        speed,
        arrows: useArrows,
        nextArrow: <CustomArrow isSmall={smallArrows} direction={NEXT} onArrowClick={onArrowClick}/>,
        prevArrow: <CustomArrow isSmall={smallArrows} direction={PREV} onArrowClick={onArrowClick}/>,
        centerMode: false,
        slidesToShow,
        slidesToScroll,
        responsive: [],

        // Unknown historical workaround with !isInfinity.
        // Some issues were posted about useTransform in slick-slider repo. Extra check was added to avoid risks.
        // Consumers can pass it directly and test on their side
        useTransform: typeof useTransform !== 'undefined' ? useTransform : !isInfinite,
        initialSlide,
        autoplay,
        autoplaySpeed,
        easing
    };

    breakpoints.forEach((bp) => {
        const { breakpoint, slides, slidesToScroll: bpSlidesToScroll } = bp;
        sliderSettings.responsive.push({
            breakpoint,
            settings: {
                slidesToShow: slides,
                slidesToScroll: bpSlidesToScroll || slidesToScroll
            }
        });
    });

    return sliderSettings;
};
